import { CustomWindow } from '../types';

declare const window: CustomWindow;

const API_SCRIPT_URL = 'https://www.youtube.com/iframe_api';

let apiReady: Promise<void> | undefined;

export const whenYouTubeApiReady = (): Promise<void> => {
  if (!apiReady) {
    apiReady = new Promise<void>((resolve) => {
      if (window.YT?.Player) {
        resolve();
        return;
      }

      const previousCallback = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        previousCallback?.();
        resolve();
      };

      if (!document.querySelector(`script[src="${API_SCRIPT_URL}"]`)) {
        const script = document.createElement('script');
        script.src = API_SCRIPT_URL;
        document.head.appendChild(script);
      }
    });
  }

  return apiReady;
};
